import { Route, Routes } from 'react-router-dom';

import EnrollmentPage from '@/components/enrollments/enrollment-page';

import LearnerPage from './learner-page';
import LearnersPage from './learners-page';

export default function Learners() {
    return (
        <Routes>
            <Route
                path="/"
                element={<LearnersPage />}
            />

            <Route
                path="/:id"
                element={<LearnerPage />}
            />

            <Route
                path="/:learnerId/enrollments/:enrollmentId"
                element={<EnrollmentPage />}
            />
        </Routes>
    );
}